import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  Typography,
  useMediaQuery, // <-- Add this import
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ProductList from "./ProductList";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

const ProductManagement = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [openImage, setOpenImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [loading, setLoading] = useState(true);

  // Fetch products from the backend
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const response = await fetch("https://enzo-matr.onrender.com/api/products");
        if (!response.ok) {
          throw new Error("Failed to fetch products");
        }
        const data = await response.json();
        setProducts(data);
        setFilteredProducts(data);
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);

    const filtered = products.filter(
      (product) =>
        product.name.toLowerCase().includes(value) || product.state.toLowerCase().includes(value)
    );
    setFilteredProducts(filtered);
  };

  const handleFilter = (filter) => {
    if (filter === "all") {
      setFilteredProducts(products);
    } else if (filter === "India") {
      setFilteredProducts(products.filter((product) => product.state === "India"));
    } else if (filter === "Saudi") {
      setFilteredProducts(products.filter((product) => product.state === "Saudi"));
    }
  };

  const handleImageClick = (img) => {
    setSelectedImage(img);
    setOpenImage(true);
  };

  const handleCloseImage = () => {
    setOpenImage(false);
    setSelectedImage("");
  };

  // Add media queries
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTab = useMediaQuery("(max-width:1024px)");
  const isMobileOrTab = isMobile || isTab;

  return (
    <Paper
      sx={{
        background: "#eeecec",
        fontFamily: "Canada Serif, serif",
        width: "100vw",
        height: "100vh",
        minHeight: "100vh",
        position: "fixed",
        overflow: "auto",
        zIndex: 1,
      }}
    >
      {/* Header */}
      <div style={{ fontFamily: "Canada Serif, serif", width: "100%", background: "#fdb913", height: "45px", textAlign: "center", fontSize: "30px", color: "white", lineHeight: "50px", fontWeight: "bold" }}>
        PRODUCT REPORT
      </div>

      <Grid
        container
        spacing={2}
        sx={{
          display: "flex",
          alignItems: "flex-start",
          mt: 0.2,
          ml: isMobileOrTab ? 0 : "5px",
          flexDirection: isMobileOrTab ? "column" : "row", // Stack on mobile/tab
        }}
      >
        {/* Table Section */}
        <Grid
          item
          xs={isMobileOrTab ? 12 : 8.7}
          sx={{
            marginLeft: isMobileOrTab ? 0 : "20px",
            width: isMobileOrTab ? "95%" : "auto",
            mb: isMobileOrTab ? 2 : 0,
            ml: isMobileOrTab ? 3 : "0px",
          }}
        >
          <Card>
            <CardContent>
              <Grid container spacing={1} alignItems="center" sx={{ marginBottom: "10px" }}>
                <Grid item xs={4}>
                  <TextField
                    variant="outlined"
                    placeholder="Search Item"
                    size="small"
                    fullWidth
                    value={searchTerm}
                    onChange={handleSearch}
                    InputProps={{ sx: { borderRadius: "10px", border: "1px solid", fontFamily: "Canada Serif, serif" } }}
                  />
                </Grid>
                <Grid item>
                  <IconButton sx={{ background: "black", color: "white", borderRadius: "10px" }}>
                    <SearchIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={2}>
                  <Button onClick={() => handleFilter("India")} variant="contained" sx={{ background: "#fdb913", color: "black", borderRadius: "10px", fontWeight: "bold", textTransform: "none", border: "1px solid black", fontFamily: "Canada Serif, serif", fontSize: "19px" }} fullWidth>
                    Indian
                  </Button>
                </Grid>
                <Grid item xs={2}>
                  <Button onClick={() => handleFilter("Saudi")} variant="contained" sx={{ background: "#fdb913", color: "black", borderRadius: "10px", fontWeight: "bold", textTransform: "none", border: "1px solid black", fontFamily: "Canada Serif, serif", fontSize: "19px" }} fullWidth>
                    Saudi
                  </Button>
                </Grid>
                <Grid item xs={3}>
                  <Button onClick={() => handleFilter("all")} variant="contained" sx={{ background: "#333", color: "white", borderRadius: "10px", fontWeight: "bold", textTransform: "none", fontFamily: "Canada Serif, serif", fontSize: "19px" }} fullWidth>
                    View All
                  </Button>
                </Grid>
              </Grid>
              <TableContainer
                component={Paper}
                sx={{
                  borderRadius: 2,
                  overflow: "auto",
                  minHeight: 410,
                  maxHeight: 410,
                  width: "100%",
                  boxShadow: "none",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                  "-ms-overflow-style": "none",
                  "scrollbar-width": "none",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                }}
              >
                {loading ? (
                  <div style={{ width: "100%", textAlign: "center" }}>
                    <CircularProgress
                      size={40}
                      thickness={5}
                      sx={{
                        color: "#FFB400",
                        '& .MuiCircularProgress-circle': { stroke: "#000" },
                      }}
                    />
                    <Typography sx={{ mt: 1, color: "#FFB400", fontWeight: "bold" }}>
                      Loading...
                    </Typography>
                  </div>
                ) : (
                  <Table size="small">
                    <TableHead sx={{ bgcolor: "#333", position: "sticky", top: 0, zIndex: 1000 }}>
                      <TableRow>
                        {["Image", "Added Date", "Product Details", "Location", "Count", "Discount", "VAT", "Price"].map((header) => (
                          <TableCell key={header} sx={{ color: "white", fontWeight: "bold", fontSize: "17px", fontFamily: "Canada Serif, serif", padding: "6px" }}>
                            {header}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredProducts.map((product) => (
                        <TableRow key={product._id}>
                          <TableCell>
                            <img
                              src={product.image || "download.png"}
                              alt="Product Logo"
                              style={{ width: "30px", height: "30px", borderRadius: "50%", cursor: "pointer" }}
                              onClick={() => handleImageClick(product.image || "download.png")}
                            />
                          </TableCell>
                          <TableCell>{product.date}</TableCell>
                          <TableCell>
                            <b>{product.name}</b>
                            <div style={{ fontSize: "10px", color: "#555", marginLeft: "30px" }}>{product.company}</div>
                          </TableCell>
                          <TableCell>{product.state}</TableCell>
                          <TableCell
                            style={{
                              color: product.count <= product.previous ? "red" : "inherit",
                            }}
                          >
                            {product.count}
                          </TableCell>
                          <TableCell>{product.discount}</TableCell>
                          <TableCell>{product.vat}</TableCell>
                          <TableCell>{product.price}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
              {/* Image Dialog */}
              <Dialog open={openImage} onClose={handleCloseImage} maxWidth="xs" PaperProps={{ sx: { borderRadius: "50%" } }}>
                <DialogContent sx={{ display: "flex", justifyContent: "center", alignItems: "center", background: "transparent", p: 2 }}>
                  <img
                    src={selectedImage}
                    alt="Profile"
                    style={{
                      width: 220,
                      height: 220,
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "6px solid #fff",
                      boxShadow: "0 0 24px rgba(0,0,0,0.18)"
                    }}
                  />
                </DialogContent>
              </Dialog>
            </CardContent>
          </Card>
        </Grid>
        {/* Product List */}
        <Grid
          item
          xs={isMobileOrTab ? 12 : 3}
          sx={{
            width: isMobileOrTab ? "100%" : "auto",
            mt: isMobileOrTab ? 2 : 0,
          }}
        >
          <ProductList />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ProductManagement;
